/**
 * Convert USD amounts in the announcement bar to the active presentment currency.
 *
 * The free-shipping threshold is $100 USD; Shopify Markets converts it at the
 * live rate at checkout (MoonBundle's progress bar already shows the converted
 * figure). The banner is static text, so "$100" is wrong in every non-USD
 * market. This rewrites any $<number> inside .announcement-bar using
 * window.Shopify.currency.rate — the same rate object the storefront exposes
 * and checkout uses — rounded UP to a clean step so the promise is always
 * conservative (customers qualify at or before the advertised amount).
 *
 * Idempotency: converted containers get data-al-currency-done. The vendor
 * marquee clones its first child to fill the width (cloneNode(true) copies
 * attributes), so clones of converted content are skipped; clones of
 * unconverted content are each converted exactly once via the observer.
 * Without a $<number> match, or on USD, this is a no-op.
 */
(function () {
  'use strict';

  var AMOUNT_RE = /(^|[^A-Za-z0-9])\$\s?(\d[\d,]*(?:\.\d+)?)/g;

  function niceCeil(v) {
    var step = v >= 10000 ? 1000 : v >= 1000 ? 100 : v >= 100 ? 5 : 1;
    return Math.ceil(v / step) * step;
  }

  function formatter(currency) {
    var locale = document.documentElement.lang || 'en';
    // Generic "es" formats 4-digit numbers ungrouped ("1900 MXN"); the store's
    // Spanish market is Mexico, whose convention groups them ("$1,900").
    if (locale === 'es') locale = 'es-MX';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      });
    } catch (e) {
      return null;
    }
  }

  function convertContainer(el, rate, fmt) {
    if (el.hasAttribute('data-al-currency-done')) return;
    el.setAttribute('data-al-currency-done', '');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (!AMOUNT_RE.test(node.nodeValue)) continue;
      AMOUNT_RE.lastIndex = 0;
      node.nodeValue = node.nodeValue.replace(AMOUNT_RE, function (m, pre, num) {
        var usd = parseFloat(num.replace(/,/g, ''));
        if (!isFinite(usd)) return m;
        return pre + fmt.format(niceCeil(usd * rate));
      });
    }
  }

  function run() {
    var cur = window.Shopify && window.Shopify.currency;
    if (!cur || !cur.active || cur.active === 'USD') return true; // USD or unknown: leave "$100" as-is
    var rate = parseFloat(cur.rate);
    if (!isFinite(rate) || rate <= 0) return false; // not ready yet
    var fmt = formatter(cur.active);
    if (!fmt) return true;

    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      // Convert existing content (pre- or post-clone, the marker keeps it once-only)
      bar.querySelectorAll('.marquee').forEach(function (m) { convertContainer(m, rate, fmt); });
      // Catch marquee clones appended after us
      new MutationObserver(function (muts) {
        muts.forEach(function (mu) {
          mu.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) {
              if (n.classList.contains('marquee')) convertContainer(n, rate, fmt);
              n.querySelectorAll && n.querySelectorAll('.marquee').forEach(function (m) { convertContainer(m, rate, fmt); });
            }
          });
        });
      }).observe(bar, { childList: true, subtree: true });
    });
    return true;
  }

  function start() {
    var tries = 0;
    (function tick() {
      if (run() || ++tries > 12) return; // Shopify.currency can land slightly after DOMContentLoaded
      setTimeout(tick, 250);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
